import { EFieldValueTransform } from '@/views/Counterparties/interface';
import { Component, Vue } from 'vue-property-decorator';
import { FieldTransformer, FieldValue } from './interface';

@Component
export default class FormTransform extends Vue {

	valueTransformers: FieldTransformer = {
		[EFieldValueTransform.UPPERCASE]: this
			.transformValueToUppercase
			.bind(this),

		[EFieldValueTransform.LOWERCASE]: this
			.transformValueToLowercase
			.bind(this),

		[EFieldValueTransform.UPPERCASE_FIRST]: this
			.transformValueToUppercaseFirst
			.bind(this),
	}

	transformValueToUppercase(value: FieldValue): FieldValue {
		return value?.toString()?.toUpperCase();
	}

	transformValueToLowercase(value: FieldValue): FieldValue {
		return value?.toString()?.toLowerCase();
	}

	transformValueToUppercaseFirst(value: FieldValue): FieldValue {
		const stringValue = value?.toString() || '';

		return stringValue.slice(0, 1)?.toUpperCase() +
			stringValue.slice(1);
	}

	transformValue(
		transform: EFieldValueTransform,
		value: FieldValue,
	): FieldValue {
		const transformer = this.valueTransformers[transform] as any;

		return (transformer && transformer(value)) || value;
	}

}